// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    name: 'ServiceAlreadyAMember',
    components: {
        IconArrowBack,
        IconBase,
        IconForward
    },
    data() {
        return {
            sa_number: "",
            is_member: false,
            isselectedanswer: false,
            dictionary: {
                custom: {
                    sa_number: {
                        required: () => 'membership number is required to proceed',
                        max: 'Cannot exceed more than 11 characters',
                        numeric: 'This field only accepts numeric characters'
                    }
                }
            }
        }
    },
    methods: {
        SetValueForMembership(_element) {
            this.isselectedanswer = true;
            if (_element === 'btnMember') {
                document.getElementById("btnMember").classList.add("selected");
                this.SetButtonColor("btnMember");
                this.$parent.RemoveClassFrom('btnNotMember', 'selected');
                this.is_member = true;
                this.$parent.ServiceInsuranceProcess.is_member = this.is_member;
                this.$parent.ServiceInsuranceProcess.sa_number = null;
            } else {
                this.is_member = false;
                document.getElementById("btnNotMember").classList.add("selected");
                this.SetButtonColor("btnNotMember");
                this.$parent.RemoveClassFrom('btnMember', 'selected');
                this.$parent.ServiceInsuranceProcess.is_member = this.is_member;
            }
        },
        SetButtonColor(current_element) {
            if (current_element == 'btnMember') {
                var not_current_element = 'btnNotMember';
            } else {
                var not_current_element = 'btnMember';
            }

            document.getElementById(current_element).classList.remove("wh-btn");
            document.getElementById(current_element).classList.add("b-btn");
            document.getElementById(not_current_element).classList.remove("b-btn");
            document.getElementById(not_current_element).classList.add("wh-btn");
        },
        Next(_smallbusinessdisclaimer) {
            if (this.isselectedanswer == true) {
                if (this.is_member === true) {
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.$parent.ServiceInsuranceProcess.sa_number = this.sa_number;
                            this.$parent.ServiceNextStep(0,"FindYourService");
                        }
                    });
                } else {
                    this.$parent.ServiceNextStep(0,"FindYourService");
                }
            }
        },
        ValidateSessionData() {
          let _data = this.$parent.ServiceInsuranceProcess;
          if(_data.is_member != null) {
            this.is_member = _data.is_member;
            if(_data.is_member) {
                this.sa_number = _data.sa_number; 
                this.isselectedanswer = true;
                document.getElementById("btnMember").click();
                this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
            } else {
                document.getElementById("btnNotMember").click();
                this.isselectedanswer = true; 
            }
            
          }
           
        },

    }, 
     computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            if(this.isselectedanswer) {
            if(this.is_member) {
                if(this.fields.sa_number) {
                if(this.fields.sa_number.valid) {
                    _isvalid = true;
                } else{
                    _isvalid = false;
                }
                }
            } else {
                _isvalid = true;
            }
            } else {
            _isvalid = false;
            }
            return _isvalid;
        }
    },
    mounted() {
        this.$validator.localize('en', this.dictionary);
        this.$parent.CheckWindowPathName();
        this.ValidateSessionData(); 
        this.$parent.CurrentProcess = "ServiceInsuranceProcess";
    }
}